import { Link } from "react-router-dom";
import { Instagram, Youtube, MessageCircle, Mail, MapPin, Phone } from "lucide-react";

export default function Footer() {
    return (
        <footer data-testid="site-footer" className="bg-[#0A0A0A] border-t border-[#262626] mt-0">
            <div className="container-pad mx-auto py-20 md:py-28">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
                    <div className="md:col-span-5">
                        <Link to="/" className="inline-flex items-baseline gap-2">
                            <span className="font-display italic text-3xl text-gold">Midasis</span>
                            <span className="font-display text-3xl text-cream font-light">Elite Interiors</span>
                        </Link>
                        <p className="mt-6 text-[#A3A3A3] max-w-md leading-relaxed">
                            Crafted with precision. Spaces that tell your story. Award-winning luxury
                            interior design for residential and commercial projects across Hyderabad
                            and beyond.
                        </p>
                        <div className="mt-8 flex items-center gap-4">
                            <a data-testid="social-instagram" href="https://instagram.com" target="_blank" rel="noreferrer" className="w-11 h-11 border border-[#262626] flex items-center justify-center text-cream hover:bg-gold hover:text-[#0D0D0D] hover:border-gold transition-colors">
                                <Instagram size={18} />
                            </a>
                            <a data-testid="social-youtube" href="https://youtube.com" target="_blank" rel="noreferrer" className="w-11 h-11 border border-[#262626] flex items-center justify-center text-cream hover:bg-gold hover:text-[#0D0D0D] hover:border-gold transition-colors">
                                <Youtube size={18} />
                            </a>
                            <a data-testid="social-pinterest" href="https://pinterest.com" target="_blank" rel="noreferrer" className="w-11 h-11 border border-[#262626] flex items-center justify-center text-cream hover:bg-gold hover:text-[#0D0D0D] hover:border-gold transition-colors">
                                <span className="text-sm font-bold">P</span>
                            </a>
                            <a data-testid="social-whatsapp" href="https://wa.me/919249899999" target="_blank" rel="noreferrer" className="w-11 h-11 border border-[#262626] flex items-center justify-center text-cream hover:bg-gold hover:text-[#0D0D0D] hover:border-gold transition-colors">
                                <MessageCircle size={18} />
                            </a>
                        </div>
                    </div>

                    <div className="md:col-span-3">
                        <p className="overline mb-6">Explore</p>
                        <ul className="space-y-3 text-cream">
                            <li><Link to="/services" className="hover:text-gold transition-colors">Services</Link></li>
                            <li><Link to="/projects" className="hover:text-gold transition-colors">Projects</Link></li>
                            <li><Link to="/process" className="hover:text-gold transition-colors">Process</Link></li>
                            <li><Link to="/about" className="hover:text-gold transition-colors">About</Link></li>
                            <li><Link to="/contact" className="hover:text-gold transition-colors">Contact</Link></li>
                        </ul>
                    </div>

                    <div className="md:col-span-4">
                        <p className="overline mb-6">Studio</p>
                        <ul className="space-y-4 text-cream">
                            <li className="flex gap-3 items-start"><MapPin size={16} className="text-gold mt-1 shrink-0" /><span>Flat No. 301-B, Park View Edifice,<br/>Nandagiri Co-Op Housing Society,<br/>Jubilee Main Road, Journalist Colony,<br/>Jubilee Hills, Hyderabad, Telangana 500033</span></li>
                            <li className="flex gap-3 items-center"><Phone size={16} className="text-gold shrink-0" /><a href="tel:+919249899999" className="hover:text-gold">+91 92498 99999</a></li>
                            <li className="flex gap-3 items-center"><Mail size={16} className="text-gold shrink-0" /><a href="mailto:contact@midasiseliteinteriors.com" className="hover:text-gold">contact@midasiseliteinteriors.com</a></li>
                        </ul>
                    </div>
                </div>

                <div className="section-rule mt-16 mb-8" />
                <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-[#A3A3A3] tracking-wide">
                    <p>&copy; {new Date().getFullYear()} Midasis Elite Interiors. All rights reserved.</p>
                    <p className="uppercase tracking-[0.25em]">Hyderabad · India</p>
                </div>
            </div>
        </footer>
    );
}
